import React from "react";
import { arrayOf, bool, shape, string } from "prop-types";
import { Box, Stack, Typography } from "@mui/material";
import BaseCard from "../../BaseCard";
import MedicationRoundedIcon from "../../icons/MedicationRoundedIcon";
import DrugList from "../../DrugList";
import ComingSoonCardSection from "./ComingSoonCardSection";

const ComingSoonCard = ({ drugs = [], title, resource = null, report = null }) => {
  return (
    <BaseCard allowHover={false}>
      {(!!title || !!drugs?.length) && (
        <Box
          sx={(theme) => ({
            display: "flex",
            gap: "5px",
            flexDirection: "column",
            borderBottom: `1px solid ${theme.palette.borders.light}`,
            paddingBottom: theme.spacing(2),
            marginTop: theme.spacing(1),
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
            marginBottom: theme.spacing(0.25),
            [theme.breakpoints.up("sm")]: {
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              paddingBottom: theme.spacing(0.5),
              marginBottom: 0,
            },
          })}
        >
          <Typography component="h2" variant="h3">
            {title}
          </Typography>
          {drugs && !!drugs.length && (
            <Box
              sx={(theme) => ({
                display: "flex",
                alignItems: "center",
                [theme.breakpoints.up("sm")]: {
                  justifyContent: "space-between",
                },
              })}
            >
              <Box
                sx={(theme) => ({
                  transform: "translate(-3px, 3px)",
                  [theme.breakpoints.up("lg")]: {
                    transform: "none",
                  },
                })}
              >
                <MedicationRoundedIcon />
              </Box>
              <DrugList drugs={drugs} inlineText="Included Drugs:" inline darkChips />
            </Box>
          )}
        </Box>
      )}
      <Stack
        direction="row"
        spacing={4}
        sx={(theme) => ({
          padding: theme.spacing(2),
          flexWrap: "wrap",
        })}
      >
        {report && (
          <Box
            sx={{
              flex: {
                xs: "1 1 100%",
                md: "0 0 calc(40% - 16px)",
                lg: "0 0 calc(40% - 16px)",
              },
              minWidth: {
                xs: 0,
                md: "calc(40% - 16px)",
                lg: "calc(40% - 16px)",
              },
            }}
          >
            <ComingSoonCardSection
              type="report"
              title={report.title}
              date={report.date}
              registrationUrl={report.registrationUrl}
              videoId={report.videoId}
              description={report.description}
              isNew={report.isNew}
            />
          </Box>
        )}
        {resource && (
          <Box
            sx={{
              flex: {
                xs: "1 1 100%",
                md: "1 1 calc(60% - 16px)",
                lg: "1 1 calc(60% - 16px)",
              },
              minWidth: 0,
            }}
          >
            <ComingSoonCardSection
              type={resource.resource_type}
              title={resource.title}
              date={resource.date}
              registrationUrl={resource.registrationUrl}
              videoId={resource.videoId}
              description={resource.description}
              isNew={resource.isNew}
            />
          </Box>
        )}
      </Stack>
    </BaseCard>
  );
};

const comingSoonSectionShape = shape({
  type: string,
  title: string,
  date: string,
  registrationUrl: string,
  videoId: string,
  description: string,
  resource_type: string,
  isNew: bool,
});

ComingSoonCard.propTypes = {
  drugs: arrayOf(string),
  title: string,
  resource: comingSoonSectionShape,
  report: comingSoonSectionShape,
};

export default ComingSoonCard;
